module.exports = __webpack_public_path__ + "024361f5553a146c9dd63b729b155c10.svg";